import { get } from "services/network/endpoint"
import * as ActionTypes from "services/state/action-types"
import { BFF } from "services/network/routes"

export function getPermissions() {
  return (dispatch) => {
    const config = { client: BFF }
    const request = get("getPermissions", config)

    return dispatch({
      type: ActionTypes.GET_PERMISSIONS,
      payload: request
    })
      .then((response) => response)
      .catch((error) => {
        console.error("[Error fetching permissions]", error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/state/permissions/action.js